import {
  SandboxCombo,
  SandboxGood,
  SandboxGoodCategory,
  SandboxService,
  SandboxTariff,
} from '../types';

const zoneTariffs = [
  { hostGroupId: 1, title: 'Общий зал', costs: [220, 570, 850, 1100, 2100] },
  { hostGroupId: 2, title: 'VIP', costs: [350, 900, 1350, 1700, 3200] },
  { hostGroupId: 3, title: 'TRIO', costs: [300, 780, 1200, 1500, 2900] },
  { hostGroupId: 4, title: 'BOOTCAMP', costs: [450, 1200, 1800, 2200, 4200] },
  { hostGroupId: 5, title: 'Консоли', costs: [300, 780, 1200, 1500, 2900] },
  {
    hostGroupId: 6,
    title: 'SOLO LEVELING',
    costs: [250, 650, 950, 1250, 2300],
  },
] as const;

const tariffDurations = [3600, 10800, 18000, 36000, 86400] as const;

const tariffTitle = (zone: string, index: number): string => {
  if (index === 0) return `1 час ${zone}`;
  if (index === 1) return `3 часа ${zone}`;
  if (index === 2) return `5 часов ${zone}`;
  if (index === 3) return `Пакет Ночь ${zone}`;
  return `Пакет Сутки ${zone}`;
};

export const createTariffs = (): SandboxTariff[] => [
  ...zoneTariffs.flatMap((zone, zoneIndex) =>
    tariffDurations.map((duration, index) => ({
      __typename: 'Tariff' as const,
      origin: 'preset' as const,
      id: zoneIndex * tariffDurations.length + index + 1,
      host_group_ids: [zone.hostGroupId],
      title: tariffTitle(zone.title, index),
      duration,
      cost: zone.costs[index],
      time_from: index === 3 ? '22:00' : null,
      time_to: index === 3 ? '08:00' : null,
      use_global_discounts: true,
      has_fixed_finish_time: false,
      per_minute: false,
      pausable: false,
      booked: false,
      disable_sale_receipt_printing: false,
      kind: 'PACKET',
    }))
  ),
  {
    __typename: 'Tariff',
    origin: 'preset',
    id: zoneTariffs.length * tariffDurations.length + 1,
    host_group_ids: zoneTariffs.map((zone) => zone.hostGroupId),
    title: 'Поминутный',
    duration: 0,
    cost: 7,
    time_from: null,
    time_to: null,
    use_global_discounts: true,
    has_fixed_finish_time: false,
    per_minute: true,
    pausable: false,
    booked: false,
    disable_sale_receipt_printing: false,
    kind: 'PER_MINUTE',
  },
];

export const createCategories = (): SandboxGoodCategory[] =>
  ['Напитки', 'Снеки', 'Горячее', 'Мерч', 'Аксессуары', 'Другое'].map(
    (title, index) => ({
      __typename: 'GoodCategory',
      origin: 'preset',
      id: index + 1,
      title,
    })
  );

export const createGoods = (categories: SandboxGoodCategory[]): SandboxGood[] =>
  Array.from({ length: 24 }, (_, index) => {
    const category = categories[index % categories.length];
    return {
      __typename: 'Good' as const,
      origin: 'preset',
      id: index + 1,
      title: `${category.title} ${index + 1}`,
      cost: 80 + (index % 8) * 35,
      amount: 8 + (index % 7) * 3,
      use_global_discounts: true,
      use_fair_sign: false,
      vat: 20,
      tax_system: 'OSN',
      is_excise: false,
      available_to_buy: true,
      category,
      ean: `460000000${String(index + 1).padStart(3, '0')}`,
    };
  });

export const createServices = (): SandboxService[] =>
  [
    'Печать A4',
    'Сканирование',
    'Аренда гарнитуры',
    'Настройка аккаунта',
    'Турнирный взнос',
    'Доставка к месту',
  ].map((title, index) => ({
    __typename: 'Service',
    origin: 'preset',
    id: index + 1,
    title,
    cost: 50 + index * 100,
    wholesale_cost: 0,
    tax_percent: 20,
    use_global_discounts: index !== 4,
    created_at: '2026-06-01T09:00:00.000Z',
    vat: 20,
    tax_system: 'OSN',
  }));

export const createCombos = (
  tariffs: SandboxTariff[],
  goods: SandboxGood[],
  services: SandboxService[]
): SandboxCombo[] =>
  Array.from({ length: 6 }, (_, index) => ({
    __typename: 'Combo',
    origin: 'preset',
    id: index + 1,
    title: `Комбо ${index + 1}: игра + перекус`,
    cost: tariffs[index].cost + goods[index].cost + services[index].cost - 50,
    quantity: 1,
    use_global_discounts: false,
    tariff: index < 3 ? null : tariffs[index],
    items: [
      {
        entity_type: 'GOOD',
        amount: 1,
        price: goods[index].cost,
        entity: goods[index],
      },
      {
        entity_type: 'SERVICE',
        amount: 1,
        price: services[index].cost,
        entity: services[index],
      },
    ],
  }));
